<template>
	<div>
		<b-form>
			<b-row class="mt-4">
				<b-col xl="4" lg="4" sm="4">
					<b-form-group label-for="input-1">
						<label for="name"><b>Name</b></label>
						<b-form-input
							id="name"
							placeholder="Name"
							v-model="usersCreateForm.name"
						></b-form-input>
					</b-form-group>
				</b-col>

				<b-col xl="4" lg="4" sm="4">
					<b-form-group label-for="input-1">
						<label for="username"><b>Username</b></label>
						<b-form-input
							id="username"
							placeholder="Username"
							:state="usernameStatus"
							v-model="usersCreateForm.username"
						></b-form-input>
						<b-form-invalid-feedback v-if="usernameExists">
							This username already exists.
						</b-form-invalid-feedback>
						<b-form-invalid-feedback :state="usernameStatus">
							Please enter a valid username
						</b-form-invalid-feedback>
					</b-form-group>
				</b-col>

				<b-col xl="4">
					<b-form-group label-for="input-1">
						<label for="phone-number"><b>Phone Number</b></label>
            <!-- We need to match the same size for the css of the placeholder. vti__input-->
            <vue-tel-input
                style="font-weight: 400;line-height: 1.5;!important;"
                v-model="usersCreateForm.phoneNo"
                :defaultCountry="preferredCountry"
                :enabledCountryCode="enabledCountryCodeStatus"
                :state="phoneNoStatus"
                :validCharactersOnly="validCharactersOnly"
            ></vue-tel-input>
						<b-form-invalid-feedback :state="phoneNoStatus">
							Please enter a valid phone number.
						</b-form-invalid-feedback>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col xl="6">
					<b-form-group label-for="input-1">
						<label for="email"><b>Email</b></label>
						<b-form-input
							id="email"
							placeholder="Email"
							:state="emailStatus ? true : false"
							v-model="usersCreateForm.email"
						></b-form-input>
						<b-form-invalid-feedback :state="emailStatus">
							{{ emailStatusMessage }}
						</b-form-invalid-feedback>
					</b-form-group>
				</b-col>

				<b-col xl="6">
					<b-form-group label-for="input-1">
						<label for="password"><b>Password</b></label>
						<b-input-group>
							<b-form-input
								id="password"
								placeholder="Password"
								:type="viewPassword ? 'text' : 'password'"
								:state="passwordStatus"
								v-model="usersCreateForm.password"
								@input="setStateOverride(false)"
							>
							</b-form-input>
							<b-input-group-append>
								<b-button variant="outline-primary" @click="viewPassword = !viewPassword">
									<b-icon icon="eye-slash" v-if="viewPassword" />
									<b-icon icon="eye" v-else />
								</b-button>
							</b-input-group-append>
						</b-input-group>
						<b-form-invalid-feedback :state="stateOverride || passwordLength">
							Your password must have at least 8 chars.
						</b-form-invalid-feedback>
						<b-form-invalid-feedback :state="stateOverride || passwordUppercase">
							Your password must have at least 1 upper case letter.
						</b-form-invalid-feedback>
						<b-form-invalid-feedback :state="stateOverride || passwordNumber">
							Your password must have at least 1 number.
						</b-form-invalid-feedback>
						<b-form-invalid-feedback :state="stateOverride || passwordCharacter">
							Your password must have at least 1 special char.
						</b-form-invalid-feedback>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<label for="customerGroup"><b>Carrier</b></label>
					<b-form-select
						id="customerGroup"
						v-model="usersCreateForm.customerGroup"
						:state="customerGroupStatus"
						class="mb-1"
					>
					<!-- Hide the first option in the dropdown -->
					<template v-slot:first>
						<option value="" disabled>Select Carrier</option>
					</template>
					<option v-for="option in customerGroupOptions" :value="option.value" :key="option.value">
						{{ option.text }}
					</option>
					</b-form-select>
					<b-form-invalid-feedback :state="customerGroupStatus">
							Please select a Carrier.
					</b-form-invalid-feedback>
				</b-col>
			</b-row>
			<b-row>
        		<b-col xl="12" lg="12" sm="12">
					<b-form-group>
						<label for="roles"><b>Roles</b></label>
						<div style="display: flex; gap: 0.25em; flex-wrap: wrap" class="mb-1">
							<span v-for="role in usersCreateForm.roles">
								<b-badge href="#" :title="`Remove ${role}`" variant="primary" @click="removeRole(role)"
									>{{ role }} <b-icon icon="x"></b-icon>
								</b-badge>
							</span>
						</div>
						<b-form-select
							id="roles"
							:value="usersCreateForm.roles"
							multiple
							@mousedown.prevent
						>
							<option
								v-for="option in roleOptions"
								:value="option.value"
								:key="option.value"
								@click="onSelect"
							>
								{{ option.text }}
							</option>
						</b-form-select>
						<b-form-invalid-feedback :state="customerRoleStatus">
							Please select at least 1 Role.
						</b-form-invalid-feedback>
					</b-form-group>
				</b-col>
				<b-col xl="2" lg="2" sm="2" />
			</b-row>
			<b-row>
				<b-col>
					<div class="d-flex justify-content-end">
						<base-button type="info" title="Close" v-on:click="modalClose()"> Cancel </base-button>
						<base-button
							:disabled="submitDisabled"
							:loading="submitLoading"
							title="Save"
							type="info"
							v-on:click="usersCreateSubmit"
						>
							Save
						</base-button>
					</div>
				</b-col>
			</b-row>
		</b-form>
	</div>
</template>

<script>
import {VueTelInput} from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import administratorService from "../../common/api-services/administrator-service";
import handleResponse from "../../common/directive/handlResponse";
import AdministratorService from "@/common/api-services/administrator-service";
import initService from "../../common/api-services/init-service";
import Toast from './Toast.vue';

export default {
	name: "Users-Create",
	components: {
		VueTelInput,
	},
	props: {
		existingUsers: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			viewPassword: false,
			usersCreateForm: {
				customerGroup: "", //'Select Group',
				isReadOnly: false,
				phoneNo: "",
				email: "",
				username: "",
				password: "",
				name: "",
				roles: [],
			},
			roleOptions: [],
			customerGroupOptions: [],
			submitLoading: false,
			customer: null,
			stateOverride: false,

			//for phone number validator
			enabledCountryCodeStatus: true,
			preferredCountry: 'us',
			validCharactersOnly: true,
			dialCode: "",

		};
	},
	mounted() {
		this.getSelectGroup();
		this.customer = initService.getCustomerInfo();
		// console.log(this.customer);
	},
	computed: {

		// onSelectCountry({name, iso2, dialCode}) {
		// this.dialCode = dialCode
		// },

		submitDisabled() {
			let valid =
				this.customerRoleStatus &&
				this.phoneNoStatus &&
				this.emailStatus &&
				this.usernameStatus &&
				this.passwordStatus &&
				this.customerGroupStatus;

			return !valid;
		},
		customerGroupStatus() {
			return this.usersCreateForm.customerGroup.length > 0;
		},
		customerRoleStatus() {
			return this.usersCreateForm.roles.length > 0;
		},
		phoneNoStatus() {
			return this.usersCreateForm.phoneNo.length >= 10;
		},
		emailStatusMessage() {
			const re =
				/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			const email = String(this.usersCreateForm.email).toLowerCase();

			if (re.test(email)) {
				return ""
			}

			return "Please enter a valid email.";
		},

		emailStatus() {
			return !this.emailStatusMessage;
		},

		usernameStatus() {
			if (this.existingUsers.includes(this.usersCreateForm.username)) {
				return false;
			} else if (this.usersCreateForm.username.length < 4) {
				return false;
			} else {
				return true;
			}
		},

		usernameExists() {
      if (this.usersCreateForm.username.length < 1) {
        return false;
      }
			return this.existingUsers.includes(this.usersCreateForm.username);
		},

		passwordStatus() {
			return !!(this.passwordLength && this.passwordUppercase && this.passwordNumber && this.passwordCharacter);
		},

		passwordLength() {
			return this.usersCreateForm.password.length > 7 ? true : false;
		},

		passwordUppercase() {
			let pass = this.usersCreateForm.password;
			for (let i = 0; i < pass.length; i++) {
				if ("A" <= pass[i] && pass[i] <= "Z") {
					return true;
				}
			}
			return false;
		},

		passwordNumber() {
			let pass = this.usersCreateForm.password;
			for (let i = 0; i < pass.length; i++) {
				if ("0" <= pass[i] && pass[i] <= "9") {
					return true;
				}
			}
			return false;
		},

		passwordCharacter() {
			let format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
			if (format.test(this.usersCreateForm.password)) {
				return true;
			} else {
				return false;
			}
		},

	},
	methods: {
		getSelectGroup() {
			administratorService.getGroupList().then(res => {
				res.map((item, index) => {
					if (item.GroupName.toString()==='PORTAL_ADMIN' && !initService.getPortalAdminRole()) {
						// do not show users the PORTAL_ADMIN role unless they have the role.
					} else {
						if (item.GroupName.toString().includes('CARRIER_') && !item.GroupName.toString().includes('ADMIN')) {
							this.customerGroupOptions.push({value: item.GroupName, text: item.GroupName});
						} else {
							this.roleOptions.push({value: item.GroupName, text: item.GroupName});
						}
					}
				});
			})
			.finally(() => {
				if (this.customerGroupOptions.length === 1) {
					this.usersCreateForm.customerGroup = this.customerGroupOptions[0].value;
				}
			})
		},

		modalClose() {
			this.$bvModal.hide("add-user");
		},

		async usersCreateSubmit() {
			if (
				this.customerRoleStatus &&
				this.phoneNoStatus &&
				this.emailStatus &&
				this.usernameStatus &&
				this.passwordStatus
			) {
				this.submitLoading = true;

				//fix phoneumber to be valid, remove all char but numbers and add plus
				let phoneNum = this.usersCreateForm.phoneNo.replace(/[^0-9]+/g, "");
				if (phoneNum.length < 11) phoneNum = "1" + phoneNum;
				phoneNum = "+" + phoneNum;

				this.usersCreateForm.phoneNo =
					this.dialCode + this.usersCreateForm.phoneNo.replace("(", "").replace(")", "").trim();
				let data = btoa(
					this.usersCreateForm.username +
						"|" +
						this.usersCreateForm.email +
						"|" +
						phoneNum +
						"|" +
						this.usersCreateForm.password
				);
				//register user
				await administratorService.registerUser(data).then(res => {
					let {type, msg} = handleResponse.apiResponse(res);
					this.$toast(msg, {type: type});
				});

				//add display name
				const userArttributes = [
					{Name: "name", Value: this.usersCreateForm.name},
					{Name: "email", Value: this.usersCreateForm.email},
					{Name: "phone_number", Value: phoneNum},
				];
				await AdministratorService.updateUserProfile(this.usersCreateForm.username, userArttributes).then(
					res => {
						let {type, msg} = handleResponse.apiResponse(res);
						this.$toast(msg, {type: type});
						if (type === "error") {
							this.$bvModal.hide("add-user");
						}
					}
				);

				//add group permission
				let groups = [...this.usersCreateForm.roles, this.usersCreateForm.customerGroup].filter(
					group => group.trim() !== ""
				);
				AdministratorService.addUserToGroup(this.usersCreateForm.username, groups).then(res => {
					// console.log("addUserToGroup:", groups);
					let {type, msg} = handleResponse.apiResponse(res);
					if (type === "success") {
						this.$toast(`"PASS - Roles updated successfully"`, {type: type});
					} else {
						this.$toast(msg, {type: type});
					}
				});
				this.modalClose();
				this.$root.$emit("getUserList");
			} else {
				this.$root.$emit("danger", "Please input valid data");
			}
		},

		setStateOverride(state) {
			this.stateOverride = state;
		},

    onSelectCountry({name, iso2, dialCode}) {
		this.dialCode = dialCode
		},

		onSelect(e) {
			const option = e.target.value;

			if (/* option === "CARRIER_ADMIN" || */ option === "PORTAL_ADMIN") {
				if (this.usersCreateForm.roles.includes(option)) {
					const index = this.usersCreateForm.roles.indexOf(option);
					this.usersCreateForm.roles.splice(index, 1);
				} else {
					this.usersCreateForm.roles = [option];
				}
			} else {
				const index = this.usersCreateForm.roles.indexOf(option);

				if (index !== -1) {
					this.usersCreateForm.roles.splice(index, 1);
				} else {
					this.usersCreateForm.roles.push(option);
				}

				// const indexCarrierAdmin = this.usersCreateForm.roles.indexOf("CARRIER_ADMIN");
				// if (indexCarrierAdmin !== -1) {
				// 	this.usersCreateForm.roles.splice(indexCarrierAdmin, 1);
				// }

				const indexPortalAdmin = this.usersCreateForm.roles.indexOf("PORTAL_ADMIN");
				if (indexPortalAdmin !== -1) {
					this.usersCreateForm.roles.splice(indexPortalAdmin, 1);
				}
			}
		},

		removeRole(option) {
			const index = this.usersCreateForm.roles.indexOf(option);
			this.usersCreateForm.roles.splice(index, 1);
		},
	},
};
</script>

<style scoped>
.role-options {
	display: flex;
	flex-direction: column;
	background-color: #f3f3f3;
	border-radius: 4px;
	padding: 10px;
	margin-top: 4px;
	height: 120px;
	overflow: auto;
}

.custom-checkbox {
	margin-right: 10px;
	transform: translateX(-20px);
	margin: 2px 0px;
}

.selected-role {
	background-color: grey;
	padding: 2px 4px;
	border-radius: 4px;
	color: white;
	display: flex;
	align-items: center;
}

:deep(.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before) {
	display: none !important;
	margin-top: 0px !important;
	background-image: none !important;
}
:deep(
		.custom-checkbox .custom-control-input ~ .custom-control-label:before,
		.custom-checkbox .custom-control-input ~ .custom-control-label:after
	) {
	display: none;
	margin-top: 0px !important;
	background-image: none;
}

:deep(.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after) {
	display: none !important;
	margin-top: 0px !important;
	background-image: none !important;
}
</style>
